import { useAppSelector } from 'store/hooks';
import { PunchupAnalytics } from 'features/PunchupPages/Analytics';
import { AnalyticByEvent as AnalyticByEventComponent } from 'features/Analytics/components/AnalyticByEvent';

const AnalyticByEvent = (): JSX.Element => {
	const { isPunchup, greenZoneEnabled } = useAppSelector((state) => state.auth);
	if (isPunchup && greenZoneEnabled) return <PunchupAnalytics />;
	return <AnalyticByEventComponent />;
};

export default AnalyticByEvent;
